export default function() {
  return data[process.env.VUE_APP_LOGO_DATA_SET];
}
let data = {
  dell: {
    leftLogo: { img: "dt-logo-lockup-hz-wht-aug2017.png", width: "20vw" },
    // centerLogo: { img: "vmware-logo2.png", width: "4vw" },
    rightLogo: { img: "logo-intel-white.png", width: "1.8vw" },
    staticLogo: {
      img: "dt-logo-lockup-hz-wht-aug2017.png",
      width: "60vw"
    }
  },
  vmware: {
    leftLogo: { img: "dt-logo-lockup-hz-wht-aug2017.png", width: "20vw" },
    // rightLogo: { img: "vmware-logo2.png", width: "4vw" },
    staticLogo: { img: "vmware-logo2.png", width: "18vw" }
  }
};
